import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';

import * as ACL from '@/domain/restriction';
import { isPayModuleCompanyPermissionsLoadedSelector } from '@/domain/env';
import { isProvidersLoadedSelector } from '@/domain/paySettings';
import { useIsCompanyScopeBehind } from '@/hooks/useIsCompanyScopeBehind';

import Route404 from '@/pages/servicePage/page404';

interface RestrictedRouteForPayProps {
  children: ReactNode;
  restriction: any;
}

const RestrictedRouteForPay: React.FC<RestrictedRouteForPayProps> = ({ children, restriction }) => {
  const restrictions = useSelector(ACL.myRestriction);
  const isPayModuleCompanyPermissionsLoaded = useSelector(isPayModuleCompanyPermissionsLoadedSelector);
  const isProvidersLoaded = useSelector(isProvidersLoadedSelector);
  const isScopeBehind = useIsCompanyScopeBehind();
  const ACLFilterFN = ACL.arrayFilter(restrictions);
  const isAvailable = ACLFilterFN({ restriction });

  if (isScopeBehind) {
    return (
      <Box sx={{ width: '100%' }}>
        <LinearProgress />
      </Box>
    );
  }

  // TODO: NEED RECHECK
  if (!isAvailable && isPayModuleCompanyPermissionsLoaded && isProvidersLoaded) return <Route404 />;

  return <>{children}</>;
};

export default RestrictedRouteForPay;
